export default {
	menu: {
		notification: '',
		settings: '',
		logout: ''
	}
}